export default function urlQueryToObject(url,fullUrl)
{
	if(fullUrl)
	{
		url = url.split('#')[0].split('?').slice(1).join('?');
	}

	return url.split('&').reduce
	(
		(obj,item) =>
		{
			item = item.split('=');
			obj[item.shift()] = item.join('=');
			return obj;
		},
		{}
	);
}